module.exports = __webpack_public_path__ + "assets/img/icon-gzh-8440ec73.png";